import React, { useState, useEffect } from "react";
import { electionDate } from "../mock";

const calc = () => {
  const diff = new Date(electionDate).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / (1000 * 60 * 60 * 24)),
    h: Math.floor((diff / (1000 * 60 * 60)) % 24),
    m: Math.floor((diff / (1000 * 60)) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="bg-campaign-cream text-campaign-ink border-4 border-campaign-ink shadow-brutal w-20 h-20 sm:w-28 sm:h-28 flex items-center justify-center font-display text-3xl sm:text-5xl tabular-nums">
      {String(value).padStart(2, "0")}
    </div>
    <span className="mt-2 font-bold uppercase text-xs sm:text-sm tracking-widest text-campaign-cream">
      {label}
    </span>
  </div>
);

const Countdown = () => {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="bg-campaign-coral border-y-4 border-campaign-ink py-14 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto text-center">
        <p className="font-bold uppercase tracking-[0.3em] text-campaign-ink mb-2">
          Ostáva do volieb
        </p>
        <h2 className="font-display text-3xl sm:text-5xl text-campaign-cream mb-10">
          24. OKTÓBRA 2026
        </h2>
        <div className="flex items-start justify-center gap-3 sm:gap-8">
          <Unit value={t.d} label="Dní" />
          <Unit value={t.h} label="Hodín" />
          <Unit value={t.m} label="Minút" />
          <Unit value={t.s} label="Sekúnd" />
        </div>
      </div>
    </section>
  );
};

export default Countdown;
